import { lazy, useEffect, useState } from "react";

import { Redirect, Route, useLocation } from "react-router-dom";

import { useApp } from "@ip-contexts/app-context";
import { ProtectedRoutes } from "@ip-widgets/Tailwind/auth";

const Employees = lazy(() => import("./Employees"));
const EmployeesDetails = lazy(() => import("./Employees/Details"));
const Payrolls = lazy(() => import("./Payrolls"));
const PayrollsDetails = lazy(() => import("./Payrolls/Details"));
const ReviewLines = lazy(() => import("./ReviewLines"));
const Tools = lazy(() => import("./Tools"));

export default function Accounting() {
  const [loading, setLoading] = useState(true);
  const { state, dispatch } = useApp();
  const location = useLocation();

  const department = "accounting";
  const departmentPath = `/${department}`;
  const isMainPath = () => !location.pathname.includes(":");

  useEffect(() => {
    if (
      (state.department !== department || state.path !== location.pathname) &&
      state.status !== "pending"
    ) {
      dispatch({
        type: "start update",
        department,
        path: location.pathname,
      });
    }
  }, [dispatch, state.department, state.status, state.path, location.pathname]);

  useEffect(() => {
    if (state.department === department && state.path === location.pathname) {
      dispatch({
        type: "finish update",
      });
    }
  }, [dispatch, state.department, state.path, location.pathname]);

  useEffect(() => {
    if (state.status === "resolved") {
      setLoading(false);
    }
  }, [state.status]);

  if (loading) {
    return <div />;
  }
  return (
    <>
      {isMainPath() && (
        <Redirect
          exact
          from={departmentPath}
          to={`${departmentPath}/employees`}
        />
      )}

      <ProtectedRoutes path={departmentPath}>
        <Route exact component={Employees} path={"/employees"} />
        <Route component={EmployeesDetails} path={"/employees/:employee"} />
        <Route exact component={Payrolls} path={"/payrolls"} />
        <Route component={PayrollsDetails} path={"/payrolls/:payroll"} />
        <Route component={ReviewLines} path={"/review-lines"} />
        <Route component={Tools} path={"/tools"} />
      </ProtectedRoutes>
    </>
  );
}
